export const CRYPTO_TYPE = [
  {
    label: 'TLS',
    value: 'tls',
  },
  {
    label: 'SSL',
    value: 'ssl',
  },
]

export const MIN_AZURE_SECRET_LENGTH = 8
